import React from 'react';
import {
  ButtonSecondary,
  ButtonPrimary,
  NavBarListItem,
  ButtonTertiary,
  TextLink,
  PopoverNavigationLink,
} from '@spotify-internal/encore-creator-web';
import { Link } from 'react-router-dom';

// https://ghe.spotify.net/encore/web/issues/242
// extend encore web component type definition based on value passed into component prop
type EncoreComponentProps<
  EncoreComponent extends React.ElementType,
  Component extends React.ElementType
> = Omit<React.ComponentProps<EncoreComponent>, 'component'> &
  React.ComponentProps<Component>;

export function ButtonPrimaryAsLink(
  props: EncoreComponentProps<typeof ButtonPrimary, typeof Link>,
) {
  return <ButtonPrimary {...props} component={Link} />;
}

export function ButtonSecondaryAsLink(
  props: EncoreComponentProps<typeof ButtonSecondary, typeof Link>,
) {
  return <ButtonSecondary {...props} component={Link} />;
}

export function ButtonTertiaryAsLink(
  props: EncoreComponentProps<typeof ButtonTertiary, typeof Link>,
) {
  return <ButtonTertiary {...props} component={Link} />;
}

export function NavBarListItemAsLink(
  props: EncoreComponentProps<typeof NavBarListItem, typeof Link>,
) {
  return <NavBarListItem {...props} component={Link} />;
}

export function TextLinkAsLink(
  props: EncoreComponentProps<typeof TextLink, typeof Link>,
) {
  return <TextLink {...props} component={Link} />;
}

export function PopoverNavigationLinkAsLink(
  props: EncoreComponentProps<typeof PopoverNavigationLink, typeof Link>,
) {
  return <PopoverNavigationLink {...props} component={Link} />;
}
